import libraryObjectTypes from 'helpers/enums/entityTypes'
import libraryObjectNames from 'helpers/enums/entityTypesNames'

function getLibraryObjectName(libraryObjectType) {
	let libraryObjectName
	switch (libraryObjectType) {
		case libraryObjectTypes.LESSON:
			libraryObjectName = libraryObjectNames.LESSON
			break
		case libraryObjectTypes.BUNDLE:
			libraryObjectName = libraryObjectNames.BUNDLE
			break
		default:
			libraryObjectName = ''
			break
	}
	return libraryObjectName
}

export { getLibraryObjectName }
